import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useDeviceIdentity } from "./useDeviceIdentity";
import { usePostDeviceHeartbeatMutation } from "../store/api";

const HEARTBEAT_INTERVAL_MS = 60000;

export const useBackgroundDeviceHeartbeat = (enabled = true) => {
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const { device } = useDeviceIdentity(enabled);
  const [postHeartbeat] = usePostDeviceHeartbeatMutation();
  const requestInFlightRef = useRef(false);

  useEffect(() => {
    if (!enabled || !token || !user || !device?.deviceId || device?.isActive === false) {
      return undefined;
    }

    let isMounted = true;

    const sendHeartbeat = async () => {
      if (requestInFlightRef.current || !isMounted) return;

      requestInFlightRef.current = true;
      try {
        await postHeartbeat(device.deviceId).unwrap();
      } catch {
        // Ignore transient heartbeat failures; the next interval will retry.
      } finally {
        requestInFlightRef.current = false;
      }
    };

    sendHeartbeat();
    const intervalId = window.setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);

    return () => {
      isMounted = false;
      window.clearInterval(intervalId);
      requestInFlightRef.current = false;
    };
  }, [enabled, token, user, device?.deviceId, device?.isActive, postHeartbeat]);
};

export default useBackgroundDeviceHeartbeat;
